import { yupResolver } from '@hookform/resolvers/yup';
import { GuestFlightScheduleLiteModel } from 'api-hooks/cro/model';
import { useUpdateFlightSchedule } from 'api-hooks/cro/mutation';
import { croKey } from 'api-hooks/cro/query';
import formSetErrors from 'common/helpers/form-setError';
import { queryClient } from 'common/repositories/query-client';
import notification from 'components/common/notification';
import Separator from 'components/common/separator';
import { Form, Input } from 'components/elements';
import React from 'react';
import { useForm } from 'react-hook-form';

import {
  FlightScheduleFormSchema,
  FlightScheduleFormType,
} from './flight-schedule-form-type';
import FlightScheduleStatusSelect from './flight-schedule-status-select';
import FlightScheduleTable from './flight-schedule-table';

interface FlightScheduleFormProps {
  data: GuestFlightScheduleLiteModel[];
  onClose: () => void;
}

export default function FlightScheduleForm(props: FlightScheduleFormProps) {
  const defaultValues = React.useMemo<FlightScheduleFormType>(() => {
    return {
      data: props.data,
      flightSchedules: props.data.map((detail) => {
        return {
          ...detail,
          checkInStatus: detail.checkInStatus,
          id: detail.id,
          isCheck: false,
        };
      }),
    };
  }, [props.data]);

  const methods = useForm({
    defaultValues,
    resolver: yupResolver(FlightScheduleFormSchema()),
  });

  const { mutateAsync } = useUpdateFlightSchedule();

  const onSubmit = React.useCallback(
    async (values: FlightScheduleFormType) => {
      try {
        const result = await mutateAsync(values);
        notification.success({
          message: result.message,
        });
        queryClient.refetchQueries([croKey.flightSchedulesKey()[0]]);

        props.onClose();
      } catch (e) {
        if (e.errors) {
          formSetErrors(e.errors, methods.setError);
        }
        notification.error({
          message: e.message,
        });
      }
    },
    [methods.setError, mutateAsync, props],
  );

  return (
    <Form onSubmit={onSubmit} methods={methods}>
      <FlightScheduleStatusSelect />
      <Separator gap={16} />
      <FlightScheduleTable />
      <Separator gap={16} />
      <Input type="submit" />
    </Form>
  );
}
